<template>
  <Flex direction="column">
    <Terminal
      v-for="terminalOrder in terminalOrders"
      :key="terminalOrder.id"
      :terminalOrder="terminalOrder"
      v-test="'sp-dashboard-terminal-order'"
    />
    <Terminal
      v-for="terminal in terminals"
      :key="terminal.id"
      :terminal="terminal"
      v-test="'sp-dashboard-terminal'"
    />
  </Flex>
</template>
<script
  setup
  lang="ts"
>
import type { AdyenTerminalOrder, PosTerminal } from '@/types';
import Terminal from './Terminal.vue';

defineProps<{
  terminals: PosTerminal[];
  terminalOrders: AdyenTerminalOrder[];
}>();
</script>
